import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-20af0d44"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex justify-content-between gap-2" }
const _hoisted_2 = { class: "flex gap-2" }
const _hoisted_3 = { class: "p-input-icon-left float-right" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-center py-4" }, "Nu au avut loc consultații", -1))

import { ref, PropType, watch, computed } from 'vue';
import { useRouter } from 'vue-router';

import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import Button from 'primevue/button';
import IconField from 'primevue/iconfield';
import InputIcon from 'primevue/inputicon';
import InputText from 'primevue/inputtext';
import Calendar from 'primevue/calendar';
import Tag from 'primevue/tag';

import { Consultation } from '@/interfaces/Consultation';
import type { Doctor } from '@/interfaces/Doctor';

import { DateUtils } from '@/utils/DateUtils';

export default /*#__PURE__*/_defineComponent({
  __name: 'ConsultationList',
  props: {
  consultations: {
    type: Array as PropType<Consultation[]>,
    default: () => []
  },
  mode: {
    type: String as PropType<'doctor' | 'patient' | 'none'>,
    default: 'none'
  },
  doctors: {
    type: Array as PropType<Doctor[]>,
    default: () => []
  }
},
  setup(__props) {

const props = __props;

const router = useRouter();

const filteredConsultations = ref<Consultation[]>([...props.consultations]);

const getDefaultDates = () => {
  const end = new Date();
  const start = new Date(end);
  start.setFullYear(start.getFullYear() - 1);
  return { start, end };
};

const { start: defaultStart, end: defaultEnd } = getDefaultDates();
const startDate = ref<Date>(defaultStart);
const endDate = ref<Date>(defaultEnd);
const searchQuery = ref<string>('');

const getStatusLabel = (status: string): string => {
  switch (status) {
    case 'STARTED':
    case 'READY_TO_START':
      return 'Activă';
    case 'DONE':
      return 'Finalizată';
    case 'CANCELLED':
      return 'Anulată';
    default:
      return status || '-';
  }
};

const getStatusSeverity = (status: string): string => {
  switch (status) {
    case 'STARTED':
    case 'READY_TO_START':
      return 'success';
    case 'DONE':
      return 'info';
    case 'CANCELLED':
      return 'danger';
    default:
      return 'secondary';
  }
};

const getDoctorName = (consultation: Consultation): string => {
  if (!props.doctors?.length) return '-';
  const doctor = props.doctors.find(d => consultation.participants?.includes(d.id));
  if (!doctor) return '-';
  return [doctor.title, doctor.firstName, doctor.lastName].filter(Boolean).join(' ');
};

const clearFilter = () => {
  searchQuery.value = '';
  const { start, end } = getDefaultDates();
  startDate.value = start;
  endDate.value = end;
  filterData();
};

const filterData = () => {
  let data = [...props.consultations];

  if (startDate.value && endDate.value) {
    data = data.filter((c) => {
      const d = new Date(c.startDate);
      return d >= startDate.value! && d <= endDate.value!;
    });
  }

  if (searchQuery.value) {
    data = data.filter(
      (c) =>
        c.id?.toLowerCase().includes(searchQuery.value.toLowerCase()) ||
        c.ownerName?.toLowerCase().includes(searchQuery.value.toLowerCase())
    );
  }

  filteredConsultations.value = data.sort((a, b) => {
    return new Date(b.startDate).getTime() - new Date(a.startDate).getTime();
  });
};

watch(
  () => props.consultations,
  (newValue) => {
    filteredConsultations.value = [...newValue];
    filterData();
  },
  { immediate: true }
);

watch([startDate, endDate], filterData);

const computedConsultations = computed(() => filteredConsultations.value);

const consultationNumbers = computed(() => {
  const sorted = [...props.consultations].sort(
    (a, b) => new Date(a.createdTimestamp).getTime() - new Date(b.createdTimestamp).getTime()
  );
  const map: Record<string, number> = {};
  sorted.forEach((c, i) => { map[c.id] = i + 1; });
  return map;
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(DataTable), {
      value: computedConsultations.value,
      stripedRows: "",
      paginator: "",
      rows: 10,
      rowsPerPageOptions: [10, 20, 50]
    }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_unref(Calendar), {
              modelValue: startDate.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((startDate).value = $event)),
              dateFormat: "dd.mm.yy",
              placeholder: "Data start"
            }, null, 8, ["modelValue"]),
            _createVNode(_unref(Calendar), {
              modelValue: endDate.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((endDate).value = $event)),
              dateFormat: "dd.mm.yy",
              placeholder: "Data finală"
            }, null, 8, ["modelValue"])
          ]),
          _createVNode(_unref(Button), {
            type: "button",
            class: "p-button-sm",
            icon: "pi pi-filter-slash",
            outlined: "",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (clearFilter()))
          }),
          _createElementVNode("span", _hoisted_3, [
            _createVNode(_unref(IconField), null, {
              default: _withCtx(() => [
                _createVNode(_unref(InputIcon), { class: "pi pi-search" }),
                _createVNode(_unref(InputText), {
                  class: "md:w-auto w-10rem",
                  onInput: filterData,
                  modelValue: searchQuery.value,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((searchQuery).value = $event)),
                  placeholder: "Caută consultație.."
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ])
        ])
      ]),
      empty: _withCtx(() => [
        _hoisted_4
      ]),
      default: _withCtx(() => [
        _createVNode(_unref(Column), { header: "Nr. consultație" }, {
          body: _withCtx(({ data }) => [
            _createTextVNode(_toDisplayString(consultationNumbers.value[data.id]), 1)
          ]),
          _: 1
        }),
        (__props.mode === 'doctor')
          ? (_openBlock(), _createBlock(_unref(Column), {
              key: 0,
              header: "Pacient"
            }, {
              body: _withCtx(({ data }) => [
                _createTextVNode(_toDisplayString(data.ownerName || '-'), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (__props.mode === 'patient')
          ? (_openBlock(), _createBlock(_unref(Column), {
              key: 1,
              header: "Medic"
            }, {
              body: _withCtx(({ data }) => [
                _createTextVNode(_toDisplayString(getDoctorName(data)), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_unref(Column), {
          header: "Status",
          field: "status",
          sortable: ""
        }, {
          body: _withCtx(({ data }) => [
            _createVNode(_unref(Tag), {
              value: getStatusLabel(data.status),
              severity: getStatusSeverity(data.status)
            }, null, 8, ["value", "severity"])
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          header: "Start",
          field: "startDate",
          sortable: ""
        }, {
          body: _withCtx(({ data }) => [
            _createTextVNode(_toDisplayString(_unref(DateUtils).formatWithTime(data.startDate)), 1)
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          header: "Stop",
          field: "endDate",
          sortable: ""
        }, {
          body: _withCtx(({ data }) => [
            _createTextVNode(_toDisplayString(data.endDate ? _unref(DateUtils).formatWithTime(data.endDate) : '-'), 1)
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          header: "Durata",
          sortable: ""
        }, {
          body: _withCtx(({ data }) => [
            _createTextVNode(_toDisplayString(data.endDate
              ? _unref(DateUtils).daysBetween(data.startDate, data.endDate) + ' zile'
              : '-'), 1)
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          header: "Caractere",
          field: "usedCharacters",
          sortable: ""
        }, {
          body: _withCtx(({ data }) => [
            _createVNode(_unref(Tag), {
              value: Number(data.usedCharacters) < 0 ? 'N/A' : (Number(data.usedCharacters) || 0).toString()
            }, null, 8, ["value"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["value"])
  ]))
}
}

})